$(document).ready(function () {

    $('.js-faq-expand').on('click', function () {

        var wrapper = $(this).closest('.js-faq-item');

        wrapper.find('.js-faq-expand, .js-faq-content').toggleClass('open');

        var symbol = wrapper.find('.js-faq-symbol');

        // Change the symbol text based on whether 'open' class is present
        symbol.html(wrapper.find('.js-faq-content').hasClass('open') ? '<em>-</em>' : '<em>+</em>');

    });

});